
export default class GameData {

    constructor() {

        this.startCockChance = 10
        this.startBabeSafeTimer = 30
        this.startCountdown = 10
        this.startPlaybackRate = 0.4
        this.startTauntChance = 65
        this.startMasculinity = 100

        this.defaultBabeSafeTimerMinimum = 3
        this.defaultBabeSafeTimerMaximum = 6

        this.defaultTauntDurationMinimum = 6
        this.defaultTauntDurationMaximum = 10

        this.defaultCockDurationMinimum = 6
        this.defaultCockDurationMaximum = 24

        this.defaultCockChanceDecreaseAfterTriggerMinimum = 3
        this.defaultCockChanceDecreaseAfterTriggerMaximum = 8
        this.defaultCockChanceIncreaseAfterSucessChance = 80
        this.defaultCockChanceIncreaseAfterSuccessMinimum = 3
        this.defaultCockChanceIncreaseAfterSuccessMaximum = 8

        this.defaultCockChancePercentageHigh = 60
        this.defaultStaticCockChanceHigh = 30
        this.defaultCockChancePercentageVeryHigh = 80
        this.defaultStaticCockChanceVeryHigh = 50

        this.defaultMasculinityCockDecrease = 5
        this.defaultMasculinityShotsThreshold = 50
        this.defaultMasculinityBoobsIncrease = 1
        this.defaultMAsculinityBoobsIncreaseChance = 30

        this.defaultCurrencyAddBabeSuccessMin = 2
        this.defaultCurrencyAddBabeSuccessMax = 5

        
        console.log("GameData created.")
    }
}